import { useInfiniteQuery } from "@tanstack/react-query";
import { getMedia } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
function useMedia(isEnabled = true, searchTerm = "", cursorColumn = "id", cursorId = undefined, limit = 25) {
    const { rcbAuthenticationStore } = useStores();
    const mediaQuery = useInfiniteQuery(QueryKeys.getMedia(cursorColumn, cursorId, limit, searchTerm), ({ signal, pageParam })=>{
        const urlParameter = {
            cursor: pageParam || `${cursorColumn}:${cursorId ? cursorId : ""}`,
            limit
        };
        if (searchTerm && "" !== searchTerm.trim()) {
            urlParameter.search = searchTerm.trim();
        }
        return getMedia({
            params: urlParameter,
            signal,
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            }
        });
    }, {
        enabled: isEnabled,
        getPreviousPageParam: (currentPage)=>currentPage?.responseMetadata?.cursor,
        getNextPageParam: (lastPage)=>lastPage?.responseMetadata?.nextCursor,
        keepPreviousData: true
    });
    return mediaQuery;
}
export { useMedia };
